// @flow
import React from 'react';
import localeLib from 'app/common/lib/locale';
import { RequestContextConsumer } from 'app/common/react/components/RequestContext';

// Re-export here so format types can be imported with component
export const DateFormatType = localeLib.DateFormatType;

type Props = {|
  dateFormatType: $Values<typeof DateFormatType>,
  useUTC?: boolean,
  value: Date,
|};

const PrettyDate = ({ dateFormatType, useUTC = true, value }: Props) => (
  <RequestContextConsumer>
    {(requestContext) => localeLib.formatDate(requestContext.locale, value, dateFormatType, useUTC)}
  </RequestContextConsumer>
);

export default PrettyDate;
